<!--
 * @FilePath: /netHallOfficialAccounts/src/views/Setting/changeCurrenrPhone.vue
-->
<template>
  <div class="changephone-page">
    <div>
      <div class="changephone-header">
        <p>验证当前手机号</p>
        <!-- <span>系统已发送短信验证码至您当前的手机号，请查收</span>     -->
      </div>
      <div class="changephone-content">
        <van-form>
          <van-field
            label="当前手机号"
            placeholder="水司预留手机号"
            v-model="phone"
            clearable
            type="digit"
            readonly
            :rules="[{ validator: validatorPhone, message: '' }]"
          />
          <van-field
            label="验证码"
            placeholder="填写验证码"
            center
            clearable
            v-model="code"
            :maxlength="6"
          >
            <template #button>
              <van-button
                size="mini"
                type="default"
                class="sms-button"
                @click="getCode"
                :disabled="isDisabled"
                >{{ buttonContent }}</van-button
              >
            </template>
          </van-field>
        </van-form>
      </div>
      <div class="nextBtn">
        <van-button type="info" block @click="gotoNextPage">下一步</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { isMobile } from '@/utils/validator';
import { getCode, checkCode } from '../../api/home';
import store from '@/store';
import { mapState } from 'vuex';

export default {
  name: 'ChangeCurrentPhone',
  data() {
    return {
      isDisabled: false,
      buttonContent: '获取验证码',
      wait: 60,
      phone: this.$route.query.phone,
      code: '',
      nextCode: ''
    };
  },
  computed: {
    ...mapState('user', {
      pathUrl: (state) => state.pathUrl
    })
  },
  mounted() {
    console.log(this.pathUrl);
  },
  methods: {
    validatorPhone(val) {
      return isMobile(val);
    },
    async getCode() {
      if (this.validatorPhone(this.phone)) {
        this.getSendMessage();
        let arg = {
          phone: this.phone
        };
        const { status, resultData } = await getCode(arg);
        if (status === 'complete') {
          Toast('发送成功');
        } else {
          Toast('发送失败');
        }
      } else {
        Toast('请填写正确的手机号');
      }
    },
    getSendMessage() {
      if (this.wait === 0) {
        this.isDisabled = false;
        this.buttonContent = '重新获取验证码';
        this.wait = 60;
      } else {
        this.isDisabled = true;
        this.buttonContent = this.wait + 's后重新获取';
        this.wait--;
        setTimeout(() => {
          this.getSendMessage();
        }, 1000);
      }
    },
    async gotoNextPage() {
      if (!this.code) {
        return Toast('请输入验证码');
      }
      let arg = {
        code: this.code,
        phone: this.phone
      };
      const { status, resultData } = await checkCode(arg);
      if (status === 'complete') {
        this.$router.push({ path: '/Setting/ChangeNewPhone' });
      } else {
        Toast('您填写的验证码有误');
      }
    }
  }
};
</script>

<style lang="less" scoped>
.changephone-page {
  background: #ffffff;
  .changephone-header {
    padding-left: 16px;
    padding-top: 32px;
    padding-bottom: 36px;
    p {
      margin: 0px;
      font-family: PingFangSC-Medium;
      font-size: 24px;
      color: #1c2734;
      line-height: 26px;
      font-weight: 700;
      padding-bottom: 5px;
    }
    span {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #3f3f3f;
      line-height: 26px;
    }
  }
  .changephone-content {
    .sms-button {
      border-radius: 100px;
      color: #4466ad;
      border: 1px solid #4466ad;
      .van-button__text {
        font-size: 12px;
      }
    }
    .van-button {
      border-radius: 4px;
    }
    /deep/.van-cell__title {
      span {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #333333;
      }
    }
    /deep/.van-field__control {
      display: inline-block;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #5e6268;
    }
    /deep/.van-field__right-icon {
      font-size: 16px;
    }
  }
  .nextBtn {
    margin-top: 135px;
    padding-bottom: 149px;
    margin-left: 16px;
    margin-right: 16px;
    .van-button {
      border-radius: 8px;
    }
  }
}
</style>
